import React, { useEffect } from "react";
import CarMovementIcon from "assets/svgIcons/AdminDashboard/CarMovementIcon";
import { useDispatch, useSelector } from "react-redux";
import { COMMON_SERVICES } from "../../../../redux/reduxToolkitServices/_commonServices/commonServices";
import { siteId } from "redux/reduxToolkitServices/_commonApiCalls/api";
import moment from "moment";
import { useHookstate } from "@hookstate/core";
import {
  GlobalCourseIdState,
  SITEID_GLOBAL_STATE,
} from "globalStore/globalStore";
import { useTranslation } from "react-i18next";
import { API_STATUSES } from "redux/_helpers/statuses";

const CarMovement = () => {
  const { t } = useTranslation();
  const { globalCourseId } = useHookstate(GlobalCourseIdState);
  const { siteId } = useHookstate(SITEID_GLOBAL_STATE);
  const dispatch = useDispatch();
  const {
    getCarMovementState,
    getCarMovementStatus,
    siteSettingsData,
    getDashboardFeatureSetStatus,
  } = useSelector((state) => state?.commonReducers) || [];
  useEffect(() => {
    if (
      getDashboardFeatureSetStatus === API_STATUSES.SUCCESS &&
      siteId.get() !== null &&
      siteSettingsData &&
      Object.keys(siteSettingsData).length > 0
    ) {
      const theCurrQueryDate = moment(new Date())
        .utc()
        .utcOffset(-siteSettingsData?.TimeZoneOffset)
        .format("YYYY-MM-DD");

      dispatch(
        COMMON_SERVICES.getCarMovementServices(
          siteId.get(),
          theCurrQueryDate,
          localStorage.getItem("dashCourseId")
        )
      );
    }
  }, [
    getDashboardFeatureSetStatus,
    localStorage.getItem("dashCourseId"),
    siteId.get(),
    siteSettingsData,
  ]);

  return (
    <>
      <div className="header">
        <CarMovementIcon />
        <p>{t("Car_movement")}</p>
      </div>
      <div className="box-body fleet-readiness-section">
        <div>
          <div>
            <h4>
              {getCarMovementState &&
              getCarMovementState?.FirstCarMovementRoundDate
                ? moment
                    .utc(getCarMovementState?.FirstCarMovementRoundDate)
                    .utcOffset(-siteSettingsData?.TimeZoneOffset)
                    .format("LT")
                : ""}
            </h4>
            <p>{t("First_car_round")}</p>
          </div>
          <div>
            <h4>
              {getCarMovementState &&
              getCarMovementState?.LastCarMovementRoundDate
                ? moment
                    .utc(getCarMovementState?.LastCarMovementRoundDate)
                    .utcOffset(-siteSettingsData?.TimeZoneOffset)
                    .format("LT")
                : ""}
            </h4>
            <p>{t("Last_car_round")}</p>
          </div>
        </div>
      </div>
    </>
  );
};

export default CarMovement;
